export default {
    created() {
        this.listenPrint();
    },
    data() {
        return {
            isPrint: false
        }
    },
    methods: {
        listenPrint() {
            window.addEventListener('beforeprint', () => {
                this.isPrint = true;
            })
            window.addEventListener('afterprint', () => {
                this.isPrint = false;
            })
        }
    }
}
